/**
 * Strips optional surrounding quotes from env values.
 * Docker `docker run --env-file` keeps Vercel-style `"..."`, which breaks URL parsers.
 */
export function normalizeEnvUrl(value: string | undefined): string | undefined {
  if (value === undefined || value === '') {
    return undefined;
  }
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
}

/**
 * Public app origin for Better Auth and client auth.
 */
export function getPublicBaseUrl(): string | undefined {
  return normalizeEnvUrl(process.env.NEXT_PUBLIC_BASE_URL);
}
